module.exports = __webpack_public_path__ + "static/media/star-icon.1854b8b9.svg";